module.exports = __webpack_public_path__ + "img/logo.487b2c14.png";